import { createFileRoute, redirect, Navigate, useRouterState } from '@tanstack/react-router';
import { OperationsOrganizationDetailPage } from '@/features/operations/operations-organization-detail-page';

export const Route = createFileRoute('/operations/organizations/$id')({
  beforeLoad: ({ params }) => {
    if (params.id === 'new') {
      throw redirect({ to: '/operations/organizations' });
    }
  },
  component: OperationsOrganizationDetailRoute,
});

function OperationsOrganizationDetailRoute() {
  const { id: paramId } = Route.useParams();
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  const fallbackId = pathname.match(/^\/operations\/organizations\/([^/]+)\/?$/)?.[1];
  const id = paramId || fallbackId;

  if (!id) {
    if (shouldRedirectToOrganizationListOnMissingId(pathname)) {
      return <Navigate to="/operations/organizations" replace />;
    }
    return null;
  }

  return <OperationsOrganizationDetailPage organizationId={id} />;
}

export function shouldRedirectToOrganizationListOnMissingId(pathname: string): boolean {
  return pathname === '/operations/organizations' || pathname.startsWith('/operations/organizations/');
}
